"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var _PerfectScrollBarWrapper = _interopRequireDefault(require("../PerfectScrollBarWrapper/PerfectScrollBarWrapper"));

//eslint-disable-next-line
var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {};
};

var Lockedstyles = {
  AppMainContainer: {
    position: 'relative',
    flex: '1 1 auto',
    height: '100%',
    overflow: 'hidden'
  },
  PerfectScrollBar: {
    overflow: 'hidden'
  },
  scrollX: {
    overflowX: 'scroll',
    overflowy: 'hidden'
  },
  scrollY: {
    overflowX: 'hidden',
    overflowy: 'scroll'
  },
  scrollXY: {
    overflowX: 'scroll',
    overflowy: 'scroll'
  }
}; //eslint-disable-next-line

var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    AppMainContainer: {}
  };
});
/**
 * Create a wrapper over the entire APP to handle SideBars and Top/Bottom Nav Bars.
 * The wrapper is a flex Div Element and it creates 3 horizontal divs : Fake - AppContent - Fake so that All Elements are centered and resize dynamically
 */

var AppMainContainer = /*#__PURE__*/_react["default"].forwardRef(function AppMainContainer(props, ref) {
  var NoHeightCalculation = props.NoHeightCalculation,
      WithPerfectScrollbar = props.WithPerfectScrollbar,
      WithScrollBar = props.WithScrollBar,
      DisableBodyScroll = props.DisableBodyScroll,
      TopRefComponentID = props.TopRefComponentID,
      BottomRefComponentID = props.BottomRefComponentID,
      classExtendMainContainer = props.classExtendMainContainer,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["NoHeightCalculation", "WithPerfectScrollbar", "WithScrollBar", "DisableBodyScroll", "TopRefComponentID", "BottomRefComponentID", "classExtendMainContainer", "children"]);
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));

  var _React$useState = _react["default"].useState('100%'),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      ContentHeight = _React$useState2[0],
      setContentHeight = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      TopPosition = _React$useState4[0],
      setTopPosition = _React$useState4[1]; //Handling the Scroll Options


  if (DisableBodyScroll) {
    document.body.style.overflow = 'hidden';
  }

  var FinalClassMainContainer;

  if (WithScrollBar) {
    if (WithScrollBar.X && !WithScrollBar.Y) {
      FinalClassMainContainer = (0, _clsx["default"])(classes.AppMainContainer, classes.scrollX, classExtendMainContainer);
    }

    if (!WithScrollBar.X && WithScrollBar.Y) {
      FinalClassMainContainer = (0, _clsx["default"])(classes.AppMainContainer, classes.scrollY, classExtendMainContainer);
    }

    if (WithScrollBar.X && WithScrollBar.Y) {
      FinalClassMainContainer = (0, _clsx["default"])(classes.AppMainContainer, classes.scrollXY, classExtendMainContainer);
    }
  } else if (WithPerfectScrollbar) {
    FinalClassMainContainer = (0, _clsx["default"])(classes.AppMainContainer, classes.PerfectScrollBar, classExtendMainContainer);
  } else {
    FinalClassMainContainer = (0, _clsx["default"])(classes.AppMainContainer, classExtendMainContainer);
  } //Calculating Height


  var handleResize = _react["default"].useCallback(function () {
    var SideBarHeight, TopPos; //Setting the Height of the SideBar element Based on the TopRefComponentID and BottomRefComponentID

    if (TopRefComponentID && document.getElementById(TopRefComponentID)) {
      TopPos = document.getElementById(TopRefComponentID).getBoundingClientRect().height;

      if (BottomRefComponentID && document.getElementById(BottomRefComponentID)) {
        SideBarHeight = window.innerHeight - document.getElementById(TopRefComponentID).getBoundingClientRect().height - document.getElementById(BottomRefComponentID).getBoundingClientRect().height;
      } else {
        SideBarHeight = window.innerHeight - document.getElementById(TopRefComponentID).getBoundingClientRect().height;
      }
    } else {
      TopPos = 0;

      if (BottomRefComponentID && document.getElementById(BottomRefComponentID)) {
        SideBarHeight = window.innerHeight - document.getElementById(BottomRefComponentID).getBoundingClientRect().height;
      } else {
        SideBarHeight = window.innerHeight;
      }
    }

    setContentHeight(SideBarHeight);
    setTopPosition(TopPos);
  }, [TopRefComponentID, BottomRefComponentID]); //Resize Event Listener


  _react["default"].useEffect(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    return function cleanup() {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, other, {
    style: (0, _extends2["default"])({}, Lockedstyles.AppMainContainer, {
      marginTop: TopPosition,
      height: ContentHeight
    }),
    className: FinalClassMainContainer
  }), /*#__PURE__*/_react["default"].createElement(_PerfectScrollBarWrapper["default"], (0, _extends2["default"])({
    Active: WithPerfectScrollbar ? true : false
  }, other), children));
});

AppMainContainer.defaultProps = {
  NoHeightCalculation: true,
  WithScrollBar: null,
  WithPerfectScrollbar: false,
  DisableBodyScroll: false,
  TopRefComponentID: null,
  BottomRefComponentID: null,
  classExtendMainContainer: null
};
process.env.NODE_ENV !== "production" ? AppMainContainer.propTypes = {
  /**
   * If true, this becomes a simple wrapper with no height specification.
   * If False, it calculates the height to match the viewport minus the top and bottom ref elements.
   * Note : if true all other options (scrollbar and disable body scroll are set to false)
   */
  NoHeightCalculation: _propTypes["default"].bool,

  /**
   * Specify if a Scrollbar should be displayed
   * WithScrollBar={{X:false,Y:true }}
   */
  WithScrollBar: _propTypes["default"].bool,

  /**
   * Specify if perfectScrollBar should be used for the SideBarContent Element
   * See the PerfectScrollBarWrapper to see what properties can be passed.
   */
  WithPerfectScrollbar: _propTypes["default"].bool,

  /**
   * Specify if the document.body overflow properties should be hidden or not
   */
  DisableBodyScroll: _propTypes["default"].bool,

  /**
   * The id of the TopRef Component to define the margin-top value
   */
  TopRefComponentID: _propTypes["default"].string,

  /**
   * The id of the TopRef Component to define the margin-top value
   */
  BottomRefComponentID: _propTypes["default"].string,

  /**
   * Extend the class
   */
  classExtendMainContainer: _propTypes["default"].string
} : void 0;
var _default = AppMainContainer;
exports["default"] = _default;